import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { PdfViewerComponent } from 'ng2-pdf-viewer';

@Component({
  selector: 'app-viewer',
  templateUrl: './viewer.component.html',
  styleUrls: ['./viewer.component.scss']
})
export class ViewerComponent implements OnInit {
  @ViewChild(PdfViewerComponent, {static: false}) private pdfComponent: PdfViewerComponent;

  @Input() url: string = null;
  @Input() searchEnabled: boolean = true;

  PreviewSearchControl: UntypedFormControl = new UntypedFormControl('');

  constructor() { }

  ngOnInit() {
  }

  searchPreview() {
    this.pdfComponent.eventBus.dispatch('find', {
      query: this.PreviewSearchControl.value, type: 'again', caseSensitive: false, findPrevious: undefined, highlightAll: true, phraseSearch: true
    });
  }

}
